import { Component, lazy, Suspense } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { DKLabel, DKSpinner, DKButton, DKIcons, showToast, TOAST_TYPE } from "deskera-ui-library";
import AppManager from "../../managers/AppManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import AutomationManager from "./AutomationManager";
import AutomationService from "../../services/automation";
import Utility from "../../utility/Utility";
import { AUTOMATION_ELEMENT, AUTOMATION_TRIGGERS } from "./AutomationConstants";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
const DataGridHolder = lazy(() => import("../common/DataGridHolder"));

export default class Automation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
  }
  
  onView(data) {
    const workflowColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID);
    const automationId = data.rowData[workflowColumnId];

    if (automationId) {
        switch (data.reportType) {
            case "WORKFLOW":
                RouteManager.navigateToPage(PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW + "/" + automationId);
                break;
            case "COMMISSION":
                RouteManager.navigateToPage(PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION + "/" + automationId);
                break;
        }
    }
  }

  onRowDelete(data, rowData) {
    if (Array.isArray(rowData) && rowData.length > 0) {
        const payload = [];
        let trigger;
        rowData.forEach((row) => {
            const { steps } = Utility.decodeJSON(row[AutomationManager.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.JSON_DATA)]);
            if (Array.isArray(steps)) {
                trigger = steps.find((s) => s.elementType === AUTOMATION_ELEMENT.TRIGGER);
                if (trigger.type === AUTOMATION_TRIGGERS.EXPENSE_CREATED || trigger.type === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
                    payload.push(row[AutomationManager.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID)]);
                }
            }
        });

        if (payload.length > 0) {
            if (trigger.type === AUTOMATION_TRIGGERS.EXPENSE_CREATED) {
                AutomationService.updateExpenses(undefined, payload).then(
                    (response) => {
                        if (Array.isArray(response) && response.length > 0) {
                            showToast("Updated expenses successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }, (error) => {
                        showToast("Error while updating expenses", TOAST_TYPE.FAILURE);
                    }
                );
            } else if (trigger.type === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
                AutomationService.updateTimeoff(undefined, payload).then(
                    (response) => {
                        if (Array.isArray(response) && response.length > 0) {
                            showToast("Updated expenses successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }, (error) => {
                        showToast("Error while updating expenses", TOAST_TYPE.FAILURE);
                    }
                );
            }
        }
    }
  }

  render() {
    return (
      <div className="column parent-width flex-1">
        {this.props.showBanner && (
          <div className="column bg-deskera-secondary p-r mb-r border-radius-m border-m parent-width banner-holder">
            <div className="row justify-content-between">
              <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about automation here.' />
            </div>
            <div className="row mt-m ml-l">
              <DKButton
                className="border-m ml-r bg-white"
                title="Read Article"
                icon={DKIcons.ic_book}
                onClick={AppManager.showComingSoonWarning}
              />
              <DKButton
                className="border-m ml-r bg-white"
                title="Watch Video"
                icon={DKIcons.ic_video}
                onClick={AppManager.showComingSoonWarning}
              />
            </div>
          </div>
        )}
        <div className="column parent-width mb-s position-relative flex-1">
          <Suspense
            fallback={
              <div className="row justify-content-center">
                <DKSpinner />
              </div>
            }
          >
            <DataGridHolder
              tableName={TABLES.PEOPLE_AUTOMATION}
              allowRowAdd={true}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.AUTOMATION, [ACTION.EDIT])}
              allowColumnAdd={true}
              allowColumnEdit={PermissionUtils.hasAccess(MODULE.AUTOMATION, [ACTION.EDIT])}
              allowColumnDelete={true}
              allowColumnShift={true}
              allowSearch={true}
              allowFilter={true}
              allowShare={false}
              onRowEdit={(data) => {
                let data_formatted = {};
                data_formatted.data = {
                  _id: data.rowData.id,
                  cells: data.rowData,
                };
                AutomationManager.setData(data_formatted);
                RouteManager.navigateToPage(
                  PAGE_ROUTES.AUTOMATION_BUILDER + "/" + data.rowData.id
                );
              }}
              onRowDelete={(data, rowData) => {
                this.onRowDelete(data, rowData);
              }}
              addButtonConfig={
                true
                  ? [{
                      title: "+ New Automation",
                      className: "bg-button text-white ml-r",
                      onClick: () => {
                        AutomationManager.setData(null);
                        RouteManager.navigateToPage(
                          PAGE_ROUTES.AUTOMATION_BUILDER
                        );
                      },
                    }]
                  : undefined
              }
              onView={(data)=>{
                this.onView(data)
              }}
              module={MODULE.AUTOMATION}
            />
          </Suspense>
        </div>
      </div>
    );
  }
}
